import { z } from "zod";
import { ZodStringNullable } from "../../zod-types/zod-string-nullable";

export const postWikiPageSchema = z.object({
	parentPageId: ZodStringNullable,
});

export type PostWikiPageSchema = z.infer<typeof postWikiPageSchema>;
